export var IntelligentPhotoCaptureImageBatchProcessorType;
(function (IntelligentPhotoCaptureImageBatchProcessorType) {
    IntelligentPhotoCaptureImageBatchProcessorType["IMAGE_ANALYZER"] = "Image Analyzer";
    IntelligentPhotoCaptureImageBatchProcessorType["UPLOAD_FILES_BATCH_STATUS"] = "Upload Files Batch Status";
    IntelligentPhotoCaptureImageBatchProcessorType["UPDATE_PATCH"] = "Update Patch";
})(IntelligentPhotoCaptureImageBatchProcessorType || (IntelligentPhotoCaptureImageBatchProcessorType = {}));
//# sourceMappingURL=IntelligentPhotoCaptureImageBatchProcessorType.js.map